import * as React from "react";
import ReactTooltip                     from 'react-tooltip';
import {cx} from "emotion";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faCheck}                from '@fortawesome/free-solid-svg-icons';

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {EMAIL_REGEX}            from "@Common/react/cs-form/validators/email-format";
import {UseState}               from "@Common/react/use-state";
import {FloatingInput}          from "@Xpresso/routes/account/common/floating-labels/floating-input";
import './user-name-edit.scss';

export const UserNameEdit = ({user, readOnly=false}) => cs(
    consumeContext("apis"),
    ["showInput", ({}, next) => UseState({
        next,
        initValue: false
    })],
    ["userNameUpdate", ({}, next) => UseState({
        next,
        defaultValue: user?.value?.username
    })],
    ["updateSuccess", ({}, next) => UseState({
        next,
        initValue: false
    })],
    ["validation", ({userNameUpdate}, next) => next({
        email: EMAIL_REGEX.test(userNameUpdate.value),
    })],
    ["error", ({}, next) => UseState({
        next,
        initValue: null
    })],
    ["uploading", ({}, next) => UseState({next})],
    ({apis, error, showInput, updateSuccess, uploading, userNameUpdate, validation}) => (
        <div className="user-name-edit-d2nts1">
            <div className="section">
                <div className="header">
                    <div className="title" xd-qa-type="label" xd-qa-name="Username">
                        Username
                    </div>
                    {!readOnly &&
                        <a className="edit" xd-qa-type="link" xd-qa-name="Edit Manage Username" 
                            onClick={() => {
                                const toggle = !showInput.value
                                showInput.onChange(toggle)
                                userNameUpdate.onChange(user?.value?.username)
                                error.onChange(null)
                            }}>
                            {showInput.value ? "Cancel" : "Edit"}
                        </a>
                    }
                </div>
            </div>
            <div className={cx("username-edit", {visible: showInput.value})}>
                <FloatingInput 
                    classContainer={cx("input", {visible: showInput.value})}
                    classLabel="label" 
                    props={propsUserName(userNameUpdate, error)}
                    textLabel="Username"
                />
                <div className="validation">
                    { error.value ? (
                        <div className="error"
                            xd-qa-type="label" 
                            xd-qa-name="error"
                        >
                            {error.value}
                        </div>
                    ) : (
                        <div className="validation-line">
                            {validation.email ? (
                                <div className="validation-icon">
                                    <FontAwesomeIcon 
                                        className={"icon"} 
                                        icon={faCheck} 
                                        xd-qa-type="icon" 
                                        xd-qa-name="Email format check icon"
                                    />
                                </div>
                            ) : (
                                <div className="validation-spacer"/>
                            )}
                            <div className={cx("validation-label", {validated: validation.email})}
                                xd-qa-type="label" 
                                xd-qa-name="Email format"
                            >
                                Username must be an email address
                            </div>
                        </div>
                    )}
                </div>
                <div 
                    className={cx("username-save", 
                        {disabled: uploading.value || !validation.email || userNameUpdate.value === user?.value?.username},
                        {visible: showInput.value}
                    )}
                    onClick={async () => {
                        if(uploading.value || !validation.email || userNameUpdate.value === user?.value?.username) {
                            return
                        }

                        uploading.onChange(true);
                        const update = {
                            userId: user.value.id,
                            username: userNameUpdate.value.trim()
                        }                    
                        const result = await apis.next.userProfile.updateUserProfile(update)

                        if (result?.errorMessage) {
                            error.onChange(result.errorMessage)
                            uploading.onChange(false)
                            return
                        }
                        
                        updateSuccess.onChange(true)
                        await user.reload()
                        uploading.onChange(false)
                        showInput.onChange(false)
                        
                        setTimeout(updateSuccess.onChange(false), delayUpdateSuccess);
                    }}
                    xd-qa-type="button"
                    xd-qa-name="Save Username"
                >
                    Save
                </div>
            </div>
            <div className={cx("username-readonly", {hidden: showInput.value})}>
                <ReactTooltip id="userName" place="bottom" delayShow={delayToolTip} />
                <div className="username" data-for="userName" data-tip={user?.value?.username ?? ""}
                    xd-qa-type="text"
                    xd-qa-name="Username"
                >
                    {user?.value?.username ?? "Loading..."}
                </div>
                <div className={cx("username-update-message", {success: updateSuccess.value})}
                    xd-qa-type="label" 
                    xd-qa-name="username update message"
                >
                    Username updated successfully
                </div>
            </div>
        </div>
    )
)

const propsUserName = (userNameUpdate, error) => ({
    value: userNameUpdate.value ?? "Loading...",
    onChange: (e) => {
        userNameUpdate.onChange(e.target.value)
        error.onChange(null)
    },
    className: "value",
    maxLength: 60,
    "xd-qa-type": "textbox",
    "xd-qa-name": "Username",
    autoComplete: "new-password",
})

const delayToolTip = 200
const delayUpdateSuccess = 2000